const CREDIT_INTERNAL_USD = 0.01;
const DEFAULT_MARGIN_TARGET_PCT = 70;
const DEFAULT_TAX_BUFFER_PCT = 12;
export const PLAN_CREDIT_POLICIES = {
    trial: {
        id: "trial",
        audience: "individual",
        name: "Trial",
        monthlyPriceUsd: 9,
        weeklyCredits: 200,
        workspaceLimit: 1,
        seatLimit: 1,
        dailyDropCredits: 10,
        dailyDropDepth: "light",
        maxCompetitorsPerDrop: 2,
        maxAdsPerDrop: 10,
        cmoAnalysesPerWeek: 3,
        cmoMemoryNotes: 20,
        cmoMetaLookbackDays: 7,
        topUpsEnabled: false,
        marginTargetPct: 60,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    basic: {
        id: "basic",
        audience: "individual",
        name: "Basic",
        monthlyPriceUsd: 29,
        weeklyCredits: 125,
        workspaceLimit: 1,
        seatLimit: 1,
        dailyDropCredits: 10,
        dailyDropDepth: "light",
        maxCompetitorsPerDrop: 2,
        maxAdsPerDrop: 10,
        cmoAnalysesPerWeek: 7,
        cmoMemoryNotes: 50,
        cmoMetaLookbackDays: 14,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    pro: {
        id: "pro",
        audience: "individual",
        name: "Pro",
        monthlyPriceUsd: 79,
        weeklyCredits: 350,
        workspaceLimit: 2,
        seatLimit: 1,
        dailyDropCredits: 30,
        dailyDropDepth: "standard",
        maxCompetitorsPerDrop: 5,
        maxAdsPerDrop: 20,
        cmoAnalysesPerWeek: 14,
        cmoMemoryNotes: 150,
        cmoMetaLookbackDays: 30,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    pro_max: {
        id: "pro_max",
        audience: "individual",
        name: "Pro Max",
        monthlyPriceUsd: 179,
        weeklyCredits: 750,
        workspaceLimit: 5,
        seatLimit: 1,
        dailyDropCredits: 70,
        dailyDropDepth: "deep",
        maxCompetitorsPerDrop: 10,
        maxAdsPerDrop: 40,
        cmoAnalysesPerWeek: 28,
        cmoMemoryNotes: 400,
        cmoMetaLookbackDays: 60,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    business_basic: {
        id: "business_basic",
        audience: "business",
        name: "Business Basic",
        monthlyPriceUsd: 249,
        weeklyCredits: 1125,
        workspaceLimit: 5,
        seatLimit: 3,
        dailyDropCredits: 120,
        dailyDropDepth: "team",
        maxCompetitorsPerDrop: 15,
        maxAdsPerDrop: 60,
        cmoAnalysesPerWeek: 28,
        cmoMemoryNotes: 400,
        cmoMetaLookbackDays: 60,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    business_pro: {
        id: "business_pro",
        audience: "business",
        name: "Business Pro",
        monthlyPriceUsd: 499,
        weeklyCredits: 2250,
        workspaceLimit: 15,
        seatLimit: 10,
        dailyDropCredits: 250,
        dailyDropDepth: "scale",
        maxCompetitorsPerDrop: 30,
        maxAdsPerDrop: 120,
        cmoAnalysesPerWeek: 56,
        cmoMemoryNotes: 1000,
        cmoMetaLookbackDays: 90,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    business_pro_max: {
        id: "business_pro_max",
        audience: "business",
        name: "Business Pro Max",
        monthlyPriceUsd: 999,
        weeklyCredits: 4500,
        workspaceLimit: 40,
        seatLimit: 25,
        dailyDropCredits: 500,
        dailyDropDepth: "scale",
        maxCompetitorsPerDrop: 60,
        maxAdsPerDrop: 250,
        cmoAnalysesPerWeek: 84,
        cmoMemoryNotes: 2500,
        cmoMetaLookbackDays: 180,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
    internal_dev: {
        id: "internal_dev",
        audience: "business",
        name: "Internal Dev",
        monthlyPriceUsd: 0,
        weeklyCredits: 100_000,
        workspaceLimit: null,
        seatLimit: null,
        dailyDropCredits: 1_000,
        dailyDropDepth: "custom",
        maxCompetitorsPerDrop: null,
        maxAdsPerDrop: null,
        cmoAnalysesPerWeek: null,
        cmoMemoryNotes: null,
        cmoMetaLookbackDays: null,
        topUpsEnabled: true,
        marginTargetPct: 0,
        taxBufferPct: 0,
    },
    custom: {
        id: "custom",
        audience: "business",
        name: "Custom",
        monthlyPriceUsd: 249,
        weeklyCredits: 1000,
        workspaceLimit: null,
        seatLimit: null,
        dailyDropCredits: 100,
        dailyDropDepth: "custom",
        maxCompetitorsPerDrop: null,
        maxAdsPerDrop: null,
        cmoAnalysesPerWeek: null,
        cmoMemoryNotes: null,
        cmoMetaLookbackDays: null,
        topUpsEnabled: true,
        marginTargetPct: DEFAULT_MARGIN_TARGET_PCT,
        taxBufferPct: DEFAULT_TAX_BUFFER_PCT,
    },
};
export const TOP_UP_PACKS = [
    { id: "topup_10", priceUsd: 10, credits: 250, expiresAfterMonths: 12 },
    { id: "topup_25", priceUsd: 25, credits: 650, expiresAfterMonths: 12 },
    { id: "topup_50", priceUsd: 50, credits: 1400, expiresAfterMonths: 12 },
    { id: "topup_100", priceUsd: 100, credits: 3000, expiresAfterMonths: 12 },
];
export function creditsToInternalUsd(credits) {
    return roundMoney(Math.max(0, credits) * CREDIT_INTERNAL_USD);
}
export function monthlyIncludedCredits(policy) {
    return policy.id === "trial" ? policy.weeklyCredits : policy.weeklyCredits * 4;
}
export function grossMarginPct(priceUsd, internalCostUsd) {
    if (priceUsd <= 0)
        return 0;
    return Math.round(((priceUsd - internalCostUsd) / priceUsd) * 1000) / 10;
}
export function topUpMarginPct(pack) {
    return grossMarginPct(pack.priceUsd, creditsToInternalUsd(pack.credits));
}
export function quoteCustomPlan(input) {
    const marginTargetPct = input.marginTargetPct ?? DEFAULT_MARGIN_TARGET_PCT;
    const taxBufferPct = input.taxBufferPct ?? DEFAULT_TAX_BUFFER_PCT;
    const requestedMonthlyCredits = Math.max(0, Math.ceil(input.weeklyCredits)) * 4;
    const creditCost = creditsToInternalUsd(requestedMonthlyCredits);
    const workspaceCost = Math.max(1, input.workspaces) * 3;
    const seatCost = Math.max(1, input.seats) * 2;
    const dailyDropCost = creditsToInternalUsd(Math.max(0, input.dailyDropCredits) * 30);
    const estimatedInternalCostUsd = roundMoney(creditCost + workspaceCost + seatCost + dailyDropCost);
    const protectedCostShare = Math.max(1, 100 - marginTargetPct - taxBufferPct) / 100;
    const minimumMonthlyPriceUsd = roundToDollar(Math.max(249, estimatedInternalCostUsd / protectedCostShare));
    return {
        minimumMonthlyPriceUsd,
        estimatedInternalCostUsd,
        requestedMonthlyCredits,
        marginTargetPct,
        taxBufferPct,
    };
}
function roundMoney(value) {
    return Math.round(value * 100) / 100;
}
function roundToDollar(value) {
    return Math.ceil(value);
}
//# sourceMappingURL=pricing-policy.js.map